import { AxiosRequestConfig } from "axios";
import { axiosInstance } from "./axiosInstance";

const apiService = {
  get: async <T>(endpoint: string, config?: AxiosRequestConfig): Promise<T> => {
    const res = await axiosInstance.get<T>(endpoint, config);
    return res.data;
  },
  post: async <T, B = unknown>(
    endpoint: string,
    body?: B,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    const res = await axiosInstance.post<T>(endpoint, body, config);
    return res.data;
  },
  put: async <T, B = unknown>(
    endpoint: string,
    body?: B,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    const res = await axiosInstance.put<T>(endpoint, body, config);
    return res.data;
  },
  patch: async <T, B = unknown>(
    endpoint: string,
    body?: B,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    const res = await axiosInstance.patch<T>(endpoint, body, config);
    return res.data;
  },
  delete: async <T, B = unknown>(
    endpoint: string,
    body?: B,
    config?: AxiosRequestConfig,
  ): Promise<T> => {
    const res = await axiosInstance.delete<T>(endpoint, {
      ...config,
      data: body,
    });
    return res.data;
  },
};

export default apiService;
